import { Model } from "@react3l/react3l/core";

export class Sex extends Model {
  public id?: number;

  public code?: string;

  public name?: string;
}
